import React from 'react';
import { useParams } from 'react-router';
import { useQuery } from '@apollo/client';
import ProjectHeader from '../ProjectHeader';
import { GET_PROJECT_PROFILE } from 'gql/projects';
import ProfileDescriptions from './ProfileDescriptions';
import { PageContainer } from '@ant-design/pro-layout';

const Profile = () => {
  const { projectId } = useParams();
  const { data, loading } = useQuery(GET_PROJECT_PROFILE, {
    variables: { ids: [projectId], status: 'ALL' },
  });
  //  if (!loading && data?.projects?.nodes?.length === 0) return '';
  return (
    <ProjectHeader>
      <PageContainer title="Profile" loading={loading}>
        <ProfileDescriptions data={data} />
      </PageContainer>
    </ProjectHeader>
  );
};

export default Profile;
